import React, { Component } from 'react';

import AppBar from 'material-ui/AppBar';
import { Step, Stepper, StepLabel } from 'material-ui/Stepper';

import Details from './components/Details';
import DateTime from './components/DateTime';
import ChooseType from './components/ChooseType';
import Confirm from './components/Confirm';

import 'whatwg-fetch';

const STEPS = [
  'start',
  'datetime',
  'choosetype',
  'finished'
];

class Home extends Component {

  constructor(props) {
    super(props);

    this.state = {
      step: 0,
      name: '',
      nameError: false,
      phone: '',
      phoneError: false,
      email: '',
      emailError: '',
      address: '',
      addressError: false,
      numberPlate: '',
      numberPlateError: false,
      date: null,
      dateError: false,
      time: '',
      timeError: false,
      carType: null,
      washType: null,
      washPrice: 0,

      isLoading: false,

      isSmallScreen: false
    };

    this.next = this.next.bind(this);
    this.back = this.back.bind(this);
    this.updateField = this.updateField.bind(this);
    this.setCarType = this.setCarType.bind(this);
    this.setHasError = this.setHasError.bind(this);
    this.setLoading = this.setLoading.bind(this);

    this.updateDimensions = this.updateDimensions.bind(this);
  }

  next() {
    this.setState((prevState, props) => {
      return {
        step: prevState.step + 1
      };
    });
  }

  back() {
    this.setState((prevState, props) => {
      return {
        step: prevState.step - 1
      };
    });
  }

  updateField(fieldName, fieldValue) {
    //console.log('setting ' + fieldName + ' to ' + fieldValue);
    const detailsObj = {};
    detailsObj[fieldName] = fieldValue;
    this.setState(detailsObj);
  }

  setHasError(fieldName, hasError) {
    const detailsObj = {};
    detailsObj[fieldName + 'Error'] = hasError;
    this.setState(detailsObj);
  }

  setCarType(evt, idx, val) {
    this.updateField('carType', val);
  }

  setLoading(loading) {
    this.setState({
      isLoading: loading
    });
  }

  updateDimensions() {
    const width = window.innerWidth;
    const small = width < 768;
    this.setState({
      isSmallScreen: small
    });
  }

  componentDidMount() {
    window.addEventListener('resize', this.updateDimensions);
    this.updateDimensions();
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateDimensions);
  }

  render() {
    const style = {
      container: {
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        marginLeft: this.state.isSmallScreen ? '10%' : '20%',
        marginRight: this.state.isSmallScreen ? '10%' : '20%'
      },
      gap: {
        marginTop: '3vh'
      },
      navbar: {
        height: 120
      },
      navbarInner: {
        height: 120,
        marginTop: 0,
        textAlign: 'center'
      },
      imageLogo: {
        marginTop: 8,
        height: 100,
        width: 'auto'
      }
    };

    return (
      <div>
        <AppBar
          title={<img src="./logo.png" alt="logo" style={style.imageLogo} />}
          style={style.navbar}
          titleStyle={style.navbarInner}
          showMenuIconButton={false}
        />

        <div style={style.gap} />

        <div style={style.container}>
          {!this.state.isSmallScreen && 
            <Stepper activeStep={this.state.step}>
              <Step style={style.step}>
                <StepLabel>Your Details</StepLabel>
              </Step>
              <Step style={style.step}>
                <StepLabel>Car Details</StepLabel>
              </Step>
              <Step style={style.step}>
                <StepLabel>Choose Wash</StepLabel>
              </Step>
              <Step style={style.step}>
                <StepLabel>Finished</StepLabel>
              </Step>
            </Stepper>
          }

          {STEPS[this.state.step] === 'start' &&
            <Details
              next={this.next}
              details={this.state}
              updateField={this.updateField}
              setHasError={this.setHasError}
            />
          }
          {STEPS[this.state.step] === 'datetime' &&
            <DateTime
              next={this.next}
              back={this.back}
              details={this.state}
              updateField={this.updateField}
              setHasError={this.setHasError}
              setCarType={this.setCarType}
            />
          }
          {STEPS[this.state.step] === 'choosetype' &&
            <ChooseType
              updateField={this.updateField}
              details={this.state}
              next={this.next}
              back={this.back}
            />
          }
          {STEPS[this.state.step] === 'finished' &&
            <Confirm
              back={this.back}
              next={this.next}
              details={this.state}
            />
          }
        </div>

        <div id="footer">
          <div id="footerText">
            Powered by <a target="_blank" href="https://www.wipehero.com.au/">WipeHero</a> &copy; 2017
          </div>
        </div>
      </div>
    );
  }
}

export default Home;



// WEBPACK FOOTER //
// ./src/Home.js